import {FC, useContext, useState} from 'react';
import {FiltersContextUpdate} from '../Context/FiltersContext.tsx';
import useFilterHandlers from "../Hooks/useFilterHandlers.ts";

import {APP} from '../Utils/Constants.ts'

import Places from "./Filters/Places.tsx";
import Tags from "./Filters/Tags.tsx";
import Domains from "./Filters/Domains.tsx";
import Schedule from "./Filters/Schedule.tsx";
import PriceRange from "./Filters/PriceRange.tsx";
import Reset from "./Filters/Reset.tsx";
import TypeFormation from "./Filters/TypeFormation.tsx";
import FormationShortage from "./Filters/FormationShortage.tsx";
import Public from "./Filters/Public.tsx";

import {DataPageContext} from "../Context/DataPageContext.tsx";


interface FiltersProps {
  originalDatas: OriginalDatas
}

const Filters: FC<FiltersProps> = ({originalDatas}) => {

  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const { dataPage } = useContext(DataPageContext);
  const {
    handleReset
  } = useContext(FiltersContextUpdate);
  const { handleFilter, handleFilterArray, getFilterValue } = useFilterHandlers();

  return (
    <>
      <div className={'filters__sidebar sidebar-container'}>
        <span className={'desktop-title h2-override'}>
          <i className={'icon-filters'}/>
          {Drupal.t('Affiner la recherche')}
        </span>
        <button className={"mobile-open-filter " + (menuIsOpen ? 'is-open' : 'is-closed')} onClick={() => {
          setMenuIsOpen(!menuIsOpen)
        }}>
          <span className={'mobile-title'}><i className={'icon-filters'}/>{Drupal.t('Affiner la recherche')}</span>
        </button>
        <div className={'filters__wrapper ' + (menuIsOpen ? 'is-open' : 'is-closed')}>
          <div className={'filters__main'}>
            <Tags handleTags={handleFilter} value={getFilterValue(APP.FILTER.SEARCH.FIELD)}/>
            <Domains datas={originalDatas.domains} handleDomains={handleFilterArray}
                     value={getFilterValue(APP.FILTER.DOMAINS.FIELD)}/>
            <PriceRange
              title={Drupal.t('Prix')}
              value={getFilterValue(APP.FILTER.PRICERANGE.FIELD)}
              datas={originalDatas.prices.max}
              handlePriceRange={handleFilterArray}
            />
            <Places datas={originalDatas.places} handlePlaces={handleFilterArray}
                    value={getFilterValue(APP.FILTER.PLACES.FIELD)}/>
            {dataPage !== "node-page-117" ?
              <>
                <Schedule handleSchedule={handleFilter} value={getFilterValue(APP.FILTER.SCHEDULE.FIELD)}/>
              </> :
              <>
                <Public value={getFilterValue(APP.FILTER.PUBLIC.FIELD)} handlePublic={handleFilterArray}/>
                <FormationShortage handleFormationShortage={handleFilter} value={getFilterValue(APP.FILTER.SHORTAGE.FIELD)}/>
              </>
            }
            <TypeFormation datas={originalDatas.typeFormation} value={getFilterValue(APP.FILTER.TYPE_FORMATION.FIELD)} title={"Formation"} handleType={handleFilterArray}/>
            <Reset handleReset={handleReset}/>
          </div>
        </div>
      </div>
    </>
  );
}

export default Filters;
